import { SxProps } from '@mui/material';

// 595pt is the width of a printed A4 page
export const PRINT_WIDTH = 595;

// Scale factor to make components behave as if they were in a larger page.
// 595pt corresponds to the `md` breakpoint, but printed templates should
// behave as if they were in `lg` or `xl`
export const SCALE = 1 / 2;

export const PRINT_PAGE_STYLE = `
@page {
  size: A4;
}

html {
  /** Trick the responsive containers into thinking the actual page is larger, then zoom it back to fit A4 */
  zoom: ${SCALE};
}

body {
  /** PRINT_WIDTH corresponds to the width in A4 format */
  width: ${PRINT_WIDTH}pt;

  /** Force the browser to print all colors and backgrounds */
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}
`;

export const PAGE_BREAK_AVOID: SxProps = {
  pageBreakInside: 'avoid',
  breakInside: 'avoid',
};

export const COMMON_ISSUE_GROUP_SX: SxProps = {
  mb: 3,
  '& thead': { '& tr:first-child': { backgroundColor: 'grey.100', '& th': { fontWeight: 700, borderRadius: '4px', borderBottom: '0' } } },
  '& tr': { ...PAGE_BREAK_AVOID, '& td, th': { py: 1.25, ...PAGE_BREAK_AVOID } },
};

export const TABLE_LAYOUT_SX: SxProps = {
  margin: -1,
  width: 'calc(100% + 1rem)',
  tableLayout: 'fixed',
  '& > thead,tbody': {
    '& > tr': {
      ...PAGE_BREAK_AVOID,
      '& > td,th': {
        ...PAGE_BREAK_AVOID,
        p: 1,
        border: 'none',
        verticalAlign: 'top',
        '& > .MuiPaper-root': {
          height: 1,
          ...PAGE_BREAK_AVOID,
          '& > .MuiBox-root': { height: 1, ...PAGE_BREAK_AVOID },
        },
      },
    },
  },
};
